var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"viewer-container"},[_c('iframe',{attrs:{"src":_vm.viewerSrc,"width":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }